import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { LaRadioGroupOptionInterface } from './la-radio-group-option.interface';

@Component({
  selector: 'la-radio-group',
  template: `
    <div class="la-radio-group">
      <la-filter-button *ngFor="let option of options" [value]="option.value"
                        [option]="option"
                        (onSelected)="onBtnSelected($event)"
                        (onDeselected)="onBtnDeselected($event)">{{option.label}}</la-filter-button>
    </div>
  `,
  styles: [`
    .la-radio-group{display:flex}.la-radio-group .la-radio-button{margin-right:8px}.la-radio-group la-radio-button:last-child{margin-right:-8px}
  `],
  encapsulation: ViewEncapsulation.None,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: LaRadioGroupComponent,
    // useExisting: forwardRef(() => LaCheckboxGroupComponent),
    multi: true
  }],
})
export class LaRadioGroupComponent implements ControlValueAccessor {
  onChange: Function;
  onTouch: Function;
  private _optionsMap: { [key: string]: LaRadioGroupOptionInterface };
  private _value: any;


  private _options: LaRadioGroupOptionInterface[] = [];

  @Input()
  get options(): LaRadioGroupOptionInterface[] {
    return this._options;
  }

  set options(opts: LaRadioGroupOptionInterface[]) {
    if (!Array.isArray(opts)) {
      return;
    }
    this._options = opts;

    // create a map to fast search particular options by value
    this._optionsMap = opts.reduce((acc, val) => {
      acc[val.value] = val;
      return acc;
    }, {});

    // calculate form control value
    console.log('got these options');
    console.log(this.options);
    for (const opt of this.options) {
      if (opt.isActive) {
        this._value = opt.value;
        break;
      }
    }
    console.log('got this value');
    console.log(this._value);
    // notify form control
    if (this.onChange) {
      this.onChange(this._value);
    }
  }

  //
  // ControlValueAccessor Interface Methods
  //

  // Here we get function, which we need to call when we've updated value via

  // custom component UI
  registerOnChange(fn: any): void {
    this.onChange = fn;
    this.onChange(this._value);
  }

  // Here we need notify that user interacted with our Custom component
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  // TODO, figure out how to use it
  setDisabledState(isDisabled: boolean): void {
  }

  // Update custom component UI value, after form control changed via setValue method
  writeValue(newValue: any): void {
    if (newValue === null) {
      return;
    }
    console.log('write value:' + newValue);
    this._value = newValue;
    this._deselectAllButtons(newValue);
  }

  //
  // Component own methods
  //

  onBtnSelected(value: any) {
    console.log('on btn selected: ' + value);
    this._value = value;
    this._deselectAllButtons(value);
    // notify form control about changes
    this.onChange(this._value);
  }

  onBtnDeselected(value: any) {
    console.log('on btn deselected: ' + value);
    this._value = null;
    this._deselectAllButtons(value);
    // notify form control about changes
    this.onChange(this._value);
  }

  //
  // Private methods
  //

  /**
   *
   * @param exceptThisOne this is the .value of the option
   */
  private _deselectAllButtons(exceptThisOne: any): void {
    this.options.forEach(opt => {
      if (exceptThisOne !== undefined) {
        opt.isActive = opt.value === exceptThisOne;
      } else {
        opt.isActive = false;
      }
    });
  }
}
